import React from 'react';

const Loader = ({width=80}) => {
    return (
        <div className='overflow-hidden text-center mx-auto'>
            <img src="/assets/loaderAnimation.gif" alt="" className='img-fluid' width={width}/>
        </div>
    );
};

export default Loader;